@if (!loading) {
  <div>
    @if (inboundCalls.length > 0) {
      <table class="table table-bordered">
        <thead class="table-dark">
          <tr>
            <th>ID</th>
            <th>DATE CALLED</th>
            <th>CREATED BY</th>
            <th>OFFICE</th>
            <th>OUTBOUND FAX ID</th>
            <th>CALL OUTCOME</th>
          </tr>
        </thead>
        <tbody>
          @for (inboundCall of inboundCalls; track inboundCall) {
            <tr>
              <td>
                <a
                  routerLink="/capture-admin/communications/inbound-calls/{{inboundCall.id}}"
                  target="_blank"
                >{{ inboundCall.id }}</a>
              </td>
              <td>{{ inboundCall.createdAt | date: 'MM/dd/yyyy' }}</td>
              <td>{{ inboundCall.submittedBy.fullName }}</td>
              <td><app-office [office]="inboundCall.office" /></td>
              <td>{{ inboundCall.outboundFaxId }}</td>
              <td>{{ keyedInboundCallReasonOptions[inboundCall.reason].display }}</td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <p>There are no inbound calls.</p>
    }
  </div>
} @else {
  <mat-spinner />
}
